module.exports = "/_next/static/images/State-5ab1f4e1562d886144eae94993277168.png";